module.exports = __webpack_public_path__ + "static/img/jijinhui02.1788adb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dymanticLanshu/jijinhui02.jpg
// module id = 7GRV
// module chunks = 0